import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { CLIENT } from "../../Router/paths";
import { useLoader } from "../../context/LoaderContext";
import { axiosInstance } from "../../config/https";

export default function JobPostComp() {
  const { startLoader, stopLoader } = useLoader();
  const [allJobs, setAllJobs] = useState([]);
  const [filterJobs, setFilterJobs] = useState([]);
  const LoginUser = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const getJobs = () => {
      startLoader();
      axiosInstance
        .get("/api/jobposts/")
        .then((resp) => {
          stopLoader();
          const Data = resp.data;
          if (resp.status === 200 || resp.status === 201) {
            setAllJobs(Data.data);
            setFilterJobs(Data.data);
          } else {
            toast.warning(Data.msg);
          }
        })
        .catch(() => {
          stopLoader();
        });
    };
    getJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFilterChange = (event) => {
    const value = event.target.value.toLowerCase();
    const filteredData = allJobs.filter((item) =>
      item.job_title.toLowerCase().includes(value)
    );
    setFilterJobs(filteredData);
  };

  return (
    <section className="job-sec pc-p-3">
      <div className="container-fluid px-5">
        <div className="row align-items-end">
          <div className="col-lg-9">
            <div className="primary-heading color-dark">
              <h3 className="color-secondary">All job posts</h3>
              <h4>Talent Skilled in Front-End Developement</h4>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="text-right">
              <Link to={CLIENT.jobDetails} className="primary-btn secondary-bg">
                Post a New Job
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid px-5">
        <div className="myjob-table">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <form action="#" className="search-form">
                <div className="form-group mb-0">
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search Job Postings"
                    onChange={handleFilterChange}
                  />
                  <button type="button">
                    <FaSearch />
                  </button>
                </div>
              </form>
            </div>
            {/* <div className="col-lg-3">
              <button className="primary-btn black-bg">
                {" "}
                <FaSlidersH /> Filters{" "}
              </button>
            </div> */}
          </div>
          {filterJobs.map((e, i) => (
            <div className="myjob-boxes mc-t-2" key={i}>
              <div className="row">
                <div className="col-lg-8">
                  <div className="job-content">
                    <div className="row">
                      <div className="col-lg-6">
                        <h4>{e?.job_title}</h4>
                        <h5 style={{ textAlign: "justify" }}>
                          {e?.description}
                        </h5>
                        <p>Posted {e?.created_time} </p>
                        <h6>Payment - Fixed Price</h6>
                      </div>
                      <div className="col-lg-2">
                        <h4>{e?.experience_needed}</h4>
                        <p>Experience</p>
                      </div>
                      <div className="col-lg-2">
                        <h4>{e?.length}</h4>
                        <p>Project Length</p>
                      </div>
                      <div className="col-lg-2">
                        <h4>{e?.project_budget}</h4>
                        <p>Budget</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  {e.user.id === LoginUser.user.id && (
                    <div className="job-btns">
                      <ul
                        className="list-inline d-flex align-items-center justify-content-end"
                        style={{ flexWrap: "wrap" }}
                      >
                        <li className="list-inline-item">
                          <Link
                            to={CLIENT.reviewProposals(e.id)}
                            className="primary-btn secondary-bg"
                          >
                            View Proposals
                          </Link>
                        </li>
                        <li className="list-inline-item">
                          <Link
                            to={CLIENT.viewJob}
                            state={e}
                            className="primary-btn secondary-bg"
                          >
                            View Job
                          </Link>
                        </li>
                        <li className="list-inline-item">
                          <Link
                            to={CLIENT.inviteFreelancer(e.id)}
                            className="primary-btn secondary-bg"
                          >
                            Invite Freelancer
                          </Link>
                        </li>
                        {/* <li className="list-inline-item">
                          <Link
                            to={CLIENT.fileAComplain(e.id)}
                            state={e}
                            className="primary-btn secondary-bg"
                          >
                            File a Complain
                          </Link>
                        </li> */}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
          {!filterJobs.length && (
            <div className="row">
              <div className="col-md-12 mt-5">
                <h1 className="text-center">No Job Available</h1>
              </div>
            </div>
          )}
          {/* <div className="myjob-boxes">
            <div className="row align-items-center">
              <div className="col-lg-9">
                <div className="job-content">
                  <h4>Database Designer</h4>
                  <p>created job 23 hours before by You </p>
                  <h6>Drafted - 23 Aug, 2023</h6>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="job-btns">
                  <ul className="list-inline  d-flex align-items-center justify-content-end">
                    <li className="list-inline-item">
                      <Link
                        to={CLIENT.jobDetails}
                        className="primary-btn secondary-bg"
                      >
                        Edit Draft
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <a href="#" className="job-opt-btn">
                        <FaEllipsisH color="#000" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="myjob-boxes">
            <div className="row align-items-center">
              <div className="col-lg-9">
                <div className="job-content">
                  <h4>Database Designer</h4>
                  <p>created job 23 hours before by You </p>
                  <h6>Drafted - 23 Aug, 2023</h6>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="job-btns">
                  <ul className="list-inline  d-flex align-items-center justify-content-end">
                    <li className="list-inline-item">
                      <Link
                        to={CLIENT.jobDetails}
                        className="primary-btn secondary-bg"
                      >
                        Edit Draft
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <a href="#" className="job-opt-btn">
                        <FaEllipsisH color="#000" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}
